/**
 * 申诉弹窗(W-8,_shared C-5)。理由 10~500 代码点;提交 → submitAppeal → toast + invalidate。
 */
import { useState } from 'react';
import { Dialog } from '@/components/ui/Dialog';
import { submitAppeal } from '@/api/risk';
import { ServerError } from '@/api/client';
import { queryClient } from '@/lib/queryClient';
import { toast } from '@/components/ui/toast';

export const APPEAL_MIN = 10;
export const APPEAL_MAX = 500;

export function AppealDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const len = [...reason.trim()].length;
  const valid = len >= APPEAL_MIN && len <= APPEAL_MAX;

  const onSubmit = async () => {
    if (!valid || submitting) return;
    setSubmitting(true);
    try {
      await submitAppeal(reason.trim());
      toast.success('申诉已提交,请等待运营 7 天内处理');
      void queryClient.invalidateQueries({ queryKey: ['risk-status'] });
      setReason('');
      onClose();
    } catch (err) {
      toast.error(err instanceof ServerError ? err.message : '提交失败,请稍后重试');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} labelledBy="appeal-title">
      <h3 id="appeal-title">申诉</h3>
      <p className="sm muted mb-4">请说明申诉理由,运营将在 7 天内处理。</p>
      <textarea
        className="textarea"
        style={{ minHeight: 140 }}
        placeholder="请输入申诉理由(10-500 字)"
        maxLength={APPEAL_MAX + 50}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
      <p className="hint">
        {len}/{APPEAL_MAX}
        {len > 0 && len < APPEAL_MIN ? `(至少 ${APPEAL_MIN} 字)` : ''}
      </p>
      <div className="row gap-4 mt-4" style={{ justifyContent: 'flex-end' }}>
        <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>
          取消
        </button>
        <button type="button" className="btn btn-primary" disabled={!valid || submitting} onClick={onSubmit}>
          {submitting ? '提交中…' : '提交申诉'}
        </button>
      </div>
    </Dialog>
  );
}
